"use client"
import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { AddSmtpCampaignsMedia } from "../Features/smtpcampaign/Smtpcampaign";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../Appstore/store";
import { toast } from "sonner";

interface propsType {
    setFieldValue: (key: string, value: string) => void,
    value: string,
    formikKey: string,
    placeholder?: string,
}

export default function CustomEditor({ setFieldValue, value, formikKey, placeholder }: propsType) {
    const dispatch = useDispatch<AppDispatch>();
    function uploadAdapter(loader: any) {
        return {
            upload: () => {
                return new Promise(async (resolve, reject) => {
                    const file = await loader.file;
                    const formData = new FormData();
                    formData.append("filename", file);
                    try {
                        const response: any = await dispatch(AddSmtpCampaignsMedia({ formData }));
                        if (response.payload?.status === "success") {
                            resolve({ default: response.payload?.fileUrl });
                        }
                    } catch (error) {
                        toast.error("Image upload failed");
                        reject(error);
                    }
                })
            }
        }
    }

    function uploadPlugin(editor: any) {
        editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
            return uploadAdapter(loader);
        }
    }

    return (
        <CKEditor
            editor={ClassicEditor}
            config={{
                placeholder: placeholder || "",
                licenseKey: "GPL",
                extraPlugins: [uploadPlugin],
            }}
            onChange={(event: any, editor: any) => {
                const data = editor.getData();
                setFieldValue(formikKey, !data || data === "<p>&nbsp;</p>" ? "" : data);
            }}
            data={value}
        />
    );
}
